export const SR_CLUSTER_EVENT_STOP = 'SR_CLUSTER_EVENT_STOP';
export const SR_CLUSTER_EVENT_START = 'SR_CLUSTER_EVENT_START';
export const SR_CLUSTER_EVENT_LIST = [SR_CLUSTER_EVENT_STOP, SR_CLUSTER_EVENT_START];

export const SR_CLUSTER_NAME_DEV = 'dev';
export const SR_CLUSTER_NAME_STAGING = 'staging';
export const SR_CLUSTER_NAME_LIST = [SR_CLUSTER_NAME_DEV, SR_CLUSTER_NAME_STAGING];
